import { API_URL, FEATURE_FLAGS } from '../../constants';
import { getDecryptedCookie } from '../../utils';
import { getClientLocationHeaders, resetClientLocation } from '../clientLocation';

// Activity Log (#735). Login, failed login, logout and password events happen outside the PBA
// save APIs, so the frontend reports them here. Fire and forget: never awaited, never shown to
// the user, never blocks login/logout. Does nothing while REACT_APP_AUTH_EVENT_ENABLED is off.
// NEVER put a password, OTP, reset token or any other secret in the body.

const LOGIN_REPORTED_KEY = 'pbaLoginReported';

// Field limits from the API (email 150, reason 250); empty fields are left out.
const cleanBody = (body) => {
    const clean = { event: body.event };
    if (body.business_uuid) clean.business_uuid = String(body.business_uuid);
    if (body.email) clean.email = String(body.email).trim().slice(0, 150);
    if (body.reason) clean.reason = String(body.reason).slice(0, 250);
    return clean;
};

export function reportAuthEvent(body) {
    if (!FEATURE_FLAGS.AUTH_EVENT_ENABLED) return;
    try {
        fetch(API_URL.AUTH_EVENT, {
            method: 'POST',
            credentials: FEATURE_FLAGS.SEND_CREDENTIALS ? 'include' : 'same-origin',
            keepalive: true,
            headers: { 'Content-Type': 'application/json', ...getClientLocationHeaders() },
            body: JSON.stringify(cleanBody(body))
        }).catch(() => {}); // never block the user
    } catch (e) {
        // never block the user
    }
}

// "login" once per browser session: a refresh or route change does not send it again.
export function reportLoginOnce(businessUuid) {
    if (!FEATURE_FLAGS.AUTH_EVENT_ENABLED) return;
    try {
        if (sessionStorage.getItem(LOGIN_REPORTED_KEY)) return;
        sessionStorage.setItem(LOGIN_REPORTED_KEY, 'true');
    } catch (e) {
        // storage blocked: still report this login
    }
    reportAuthEvent({ event: 'login', business_uuid: businessUuid });
}

// Called first thing in the Logout click handler, while the login cookie still exists.
// Also stops location tracking and resets its notice (Item 4); both are no-ops when their flag is off.
export function reportLogout() {
    if (FEATURE_FLAGS.AUTH_EVENT_ENABLED) {
        reportAuthEvent({ event: 'logout', business_uuid: getDecryptedCookie('bid') });
        try {
            sessionStorage.removeItem(LOGIN_REPORTED_KEY);
        } catch (e) {
            // ignore
        }
    }
    resetClientLocation();
}
